<template>
  <v-container class="mx-0 px-0" style="max-width:unset;">
    <v-tabs>
      <v-tab>Events</v-tab>
      <v-tab>Account</v-tab>

      <v-tab-item>
        <v-data-table
            :headers="eventHeaders"
            :items="events"
            sort-by="name"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-spacer></v-spacer>

                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Event
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.name"
                              label="Event name"
                              autofocus
                            ></v-text-field>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-menu
                                v-model="startMenu"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="editedItem.startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                ref="picker"
                                v-model="editedItem.startDate"
                                :max="editedItem.endDate"
                                ></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-menu
                                v-model="endMenu"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="editedItem.endDate"
                                    label="End Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                ref="picker"
                                v-model="editedItem.endDate"
                                :min="editedItem.startDate"
                                ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>

            <template v-slot:item.eventId="{ item }">
              <v-btn
                text
                color="primary"
                :to="'/applause/'+item.eventId"
              >
                {{ item.eventId }}
              </v-btn>
            </template>

            <template v-slot:item.name="props">
              <v-edit-dialog
                :return-value.sync="props.item.name"
                @save="saveField('name', props.item)"
                large
              >
                {{ props.item.name }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.name"
                    :rules="[v => v.length <= 25 || 'Input too long!']"
                    label="Event Name"
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.startDate="props">
              <v-edit-dialog
                class="px-0"
                style="min-width:unset;"
                :return-value.sync="props.item.startDate"
                @save="saveField('startDate', props.item)"
                large
              >
                {{ props.item.startDate }}
                <template v-slot:input style="min-width:unset;padding:0;" class="px-0">
                  <v-date-picker
                      ref="picker"
                      v-model="props.item.startDate"
                      :max="props.item.endDate"
                      ></v-date-picker>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.endDate="props">
              <v-edit-dialog
                class="px-0"
                :return-value.sync="props.item.endDate"
                @save="saveField('endDate', props.item)"
                large
              >
                {{ props.item.endDate }}
                <template v-slot:input style="min-width:unset;padding:0;" class="px-0">
                  <v-date-picker
                      ref="picker"
                      v-model="props.item.endDate"
                      :max="props.item.startDate"
                      ></v-date-picker>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>

          </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <UserInput 
            :id="user.id"
            :name="user.name"
          />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
  const { rest } = require('@/misc/rest')
  import { mapState } from 'vuex'
  const moment = require('moment-timezone')
  import UserInput from '@/components/UserInput'


  export default {
    name: 'Admin',

    components: {
      UserInput,
    },

    data: () => ({
        startMenu: false,
        endMenu: false,
        expanded: [],
        singleExpand: false,
        eventHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Start Date', value: 'startDate' },
          { text: 'End Date', value: 'endDate' },
          { text: 'Link', value: 'eventId', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        events: [],
        editedIndex: -1,
        editedItem: {
          name: '',
          startDate: moment().format('YYYY-MM-DD HH:mm'),
          endDate: moment().format('YYYY-MM-DD HH:mm'),
          startTime: moment().format('HH:mm'),
          endTime: moment().format('HH:mm'),
          link: '',
        },
        defaultItem: {
          name: '',
          startDate: moment().format('YYYY-MM-DD HH:mm'),
          endDate: moment().format('YYYY-MM-DD HH:mm'),
          startTime: moment().format('HH:mm'),
          endTime: moment().format('HH:mm'),
          link: '',
        },
        dialog: false,
        dialogDelete: false,
    }),

    computed: {
      ...mapState({ user: 'user'}),
      formTitle () {
        return this.editedIndex === -1 ? 'New Event' : 'Edit Event'
      },
    },

    methods: {
      getDate: function(date) {
        return moment(date).toDate()
      },

      editItem (item) {
        this.editedIndex = this.events.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.events.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.events.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
          let payload = {
              name: this.editedItem.name,
              startDate: this.editedItem.startDate,
              endDate: this.editedItem.endDate,
          }
          
        if (this.editedIndex > -1) {
          Object.assign(this.events[this.editedIndex], this.editedItem)

            rest.request(`/event/${this.editedItem.eventId}`, 'put', payload)
                .then(result => {
                if (result.success) {
                    console.log(result)
                }
              })
        } else {
          this.events.push(this.editedItem)
        }
        this.close()
      },

      saveField(col, item) {
        let payload = {}
        payload[col] = item[col]

        rest.request(`/event/${item.eventId}`, 'put', payload)
            .then(result => {
            if (result.success) {
                console.log(result)
            }
          })
      },

      initialize: function() {
        rest.request(`/events`, 'get')
          .then(result => {
            if (result.success) {
              for (let event of result.data) {
                event.startDate = moment(event.startDate).format('YYYY-MM-DD')
                event.endDate = moment(event.endDate).format('YYYY-MM-DD')
                event.startTime = moment(event.startDate).format('HH:mm')
                event.endTime = moment(event.endDate).format('HH:mm')

                this.events.push(event)
              }
            }
          })
      }
    },

    created() {
    },

    mounted() {
      this.initialize()
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
  }
</script>

<style>
.v-menu__content {
  min-width: unset !important;  
}
</style>